import React, { useEffect, useState } from 'react';
import { FaPlus, FaTrash, FaArrowLeft } from 'react-icons/fa';
import { api } from '../../utils/api';
import LoadingSpinner from '../../components/LoadingSpinner';
import {
  PageHeader, Panel, FormGroup, FormGrid, SaveBtn, SecondaryBtn, DangerBtn,
  PrimaryBtn, Toast, Row, Table,
} from './styles/AdminStyles';

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ username: '', password: '', role: 'admin' });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.get('/users');
      setUsers(Array.isArray(data) ? data : []);
    } catch (err) {
      setToast({ type: 'error', message: err.message });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setToast(null);
    try {
      await api.post('/users', form);
      setToast({ type: 'success', message: 'User created.' });
      setForm({ username: '', password: '', role: 'admin' });
      setCreating(false);
      load();
    } catch (err) {
      setToast({ type: 'error', message: err.message });
    } finally {
      setSaving(false);
    }
  };

  const toggleActive = async (u) => {
    try {
      await api.put(`/users/${u.id}`, { isActive: !u.isActive });
      load();
    } catch (err) {
      setToast({ type: 'error', message: err.message });
    }
  };

  const remove = async (u) => {
    if (!window.confirm(`Delete user "${u.username}"?`)) return;
    try {
      await api.delete(`/users/${u.id}`);
      setToast({ type: 'success', message: 'User deleted.' });
      load();
    } catch (err) {
      setToast({ type: 'error', message: err.message });
    }
  };

  if (loading) return <LoadingSpinner fullPage />;

  if (creating) {
    return (
      <form onSubmit={save}>
        <PageHeader>
          <div className="eyebrow">Users</div>
          <h1>Create User</h1>
          <p>Admin and super-admin accounts can manage site content.</p>
        </PageHeader>
        <Panel>
          <FormGrid $cols={2}>
            <FormGroup>
              <label>Username *</label>
              <input required value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} />
            </FormGroup>
            <FormGroup>
              <label>Password *</label>
              <input required type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
            </FormGroup>
            <FormGroup>
              <label>Role</label>
              <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
                <option value="admin">Admin</option>
                <option value="superAdmin">Super Admin</option>
              </select>
            </FormGroup>
          </FormGrid>
        </Panel>
        <Row>
          <SaveBtn type="submit" disabled={saving}>{saving ? 'Creating...' : 'Create User'}</SaveBtn>
          <SecondaryBtn type="button" onClick={() => setCreating(false)}><FaArrowLeft /> Back</SecondaryBtn>
          {toast && <Toast $error={toast.type === 'error'}>{toast.message}</Toast>}
        </Row>
      </form>
    );
  }

  return (
    <>
      <PageHeader>
        <div className="eyebrow">Access Control</div>
        <h1>Manage Users</h1>
        <p>Super admins can create, deactivate and remove admin accounts.</p>
      </PageHeader>

      <Row style={{ marginBottom: '1rem' }}>
        <PrimaryBtn onClick={() => setCreating(true)}><FaPlus /> New User</PrimaryBtn>
        {toast && <Toast $error={toast.type === 'error'}>{toast.message}</Toast>}
      </Row>

      <Panel>
        <Table>
          <thead>
            <tr>
              <th>Username</th>
              <th>Role</th>
              <th>Status</th>
              <th>Created</th>
              <th style={{ width: 240 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td>{u.username}</td>
                <td>{u.role}</td>
                <td>{u.isActive ? 'Active' : 'Disabled'}</td>
                <td>{u.createdAt ? new Date(u.createdAt).toLocaleDateString() : ''}</td>
                <td>
                  <Row>
                    <SecondaryBtn type="button" onClick={() => toggleActive(u)}>
                      {u.isActive ? 'Deactivate' : 'Activate'}
                    </SecondaryBtn>
                    <DangerBtn type="button" onClick={() => remove(u)}><FaTrash /></DangerBtn>
                  </Row>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Panel>
    </>
  );
};

export default ManageUsers;
